
import React, { useEffect, useState } from "react";
import "fao-design-system/fao-theme.min.css";
import { FormattedMessage } from "react-intl";
import moment from "moment";

const FooterApplication = ({ lang }) => {

  return (
    <div>
      <footer id="footer">
        {/* <div className="container-fluid"> */}
        <div className="row">
          <div className="footer-elements">
            <div className="col-8 links-footer">
              <a
                className={"bottom-links-text"}
                target="_blank"
                href={`http://www.fao.org/employment/home/en/`} rel="noreferrer"
              >
                <FormattedMessage id="Footer.jobs" />
                &nbsp; <span style={{ color: "lightgrey" }}> | </span> &nbsp;
              </a>
              <a
                className={"bottom-links-text"}
                target="_blank"
                href={`http://www.fao.org/contact-us/${lang}/`} rel="noreferrer"
              >
                <FormattedMessage id="Footer.contactus" />
                &nbsp; <span style={{ color: "lightgrey" }}> | </span> &nbsp;
              </a>
              <a
                className={"bottom-links-text"}
                target="_blank"
                href={`http://www.fao.org/contact-us/terms/${lang}/`} rel="noreferrer"
              >
                <FormattedMessage id="Footer.terms" />
                &nbsp; <span style={{ color: "lightgrey" }}> | </span> &nbsp;{" "}
              </a>
              <a
                className={"bottom-links-text"}
                target="_blank"
                href={`http://fao.org/contact-us/data-protection-and-privacy/en/`} rel="noreferrer"
              >
                <FormattedMessage id="Footer.dataprotection" />
                &nbsp; <span style={{ color: "lightgrey" }}> | </span> &nbsp;
              </a>
              <a
                className={"bottom-links-text"}
                target="_blank"
                href={`http://www.fao.org/contact-us/scam-alert/${lang}/`} rel="noreferrer"
              >
                <FormattedMessage id="Footer.scam" />
                &nbsp; <span style={{ color: "lightgrey" }}> | </span> &nbsp;{" "}
              </a>
              <a
                className={"bottom-links-text"}
                target="_blank"
                href={`https://www.fao.org/contact-us/report-misconduct/en/`} rel="noreferrer"
              >
                <FormattedMessage id="Footer.report" />
                &nbsp; <span style={{ color: "lightgrey" }}> | </span> &nbsp;{" "}
              </a>
              <a
                className={"bottom-links-text"}
                target="_blank"
                href={`https://www.fao.org/transparency/en`} rel="noreferrer"
              >
                <FormattedMessage id="Footer.transparency" />
              </a>
            </div>
            <div className="col-1 copyright">
              <p>© FAO, {moment(new Date()).format("YYYY")}</p>
            </div>
          </div>
        </div>
        {/* </div> */}
      </footer>
    </div>
  );
};

export default FooterApplication;
